import {Header} from './header';

const initHeader = () => {
  const header = new Header();
  header.init();
};

export {initHeader};
